<template>
  <div class="page_workLog">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px">
            <el-form-item label="姓名" size="small">
              <el-input v-model="listQuery.ApplyUserName" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <!-- <el-form-item label="项目名称" size="small">
              <el-select v-model="listQuery.ProjectId" placeholder="" value-key="Projectid" size="small" style="width: 180px;" clearable filterable>
                <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.Projectid"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="开始时间" size="small">
              <el-date-picker v-model="listQuery.ApplyTimeStart" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间" size="small">
              <el-date-picker v-model="listQuery.ApplyTimeEnd" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>

          </el-form>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="90px">
          <div>
            <el-form-item label="个税申报类型" size="small" label-width="115px">
              <el-select v-model="listQuery.IncomeTaxType" placeholder="" clearable filterable style="width:180px">
                <el-option value="正常工资薪金"></el-option>
                <el-option value="劳务报酬"></el-option>
                <el-option value="全年一次性奖金（一次扣税）"></el-option>
                <el-option value="全年多次性奖金（多次发放）"></el-option>
                <el-option value="解除劳动合同一次性补偿"></el-option>
                <el-option value="个税差额补发"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="OA编号" size="small">
              <el-input v-model="listQuery.oanum" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="发放公司" size="small">
              <el-input v-model="listQuery.PayrollCompany" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <!-- <el-form-item label="身份证" size="small">
              <el-input v-model="listQuery.CardId" size="small" clearable style="width:180px"></el-input>
            </el-form-item> -->

          </div>
          <!-- <div>
            <el-form-item label="服务部门" size="small">
              <el-input v-model="listQuery.name" size="small" clearable></el-input>
            </el-form-item>
            <el-form-item label="客服" size="small">
              <el-input v-model="listQuery.name" size="small" clearable></el-input>
            </el-form-item>
          </div> -->
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>收支</el-breadcrumb-item>
          <el-breadcrumb-item>日志报销</el-breadcrumb-item>
          <el-breadcrumb-item>工作日志</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
          <el-tab-pane label="工作日志" name="0"></el-tab-pane>
          <el-tab-pane label="报销单" name="1"></el-tab-pane>
          <el-tab-pane label="部门审核" name="2"></el-tab-pane>
          <el-tab-pane label="财务审核" name="3"></el-tab-pane>
          <el-tab-pane label="待打款" name="6"></el-tab-pane>
          <el-tab-pane label="打款中" name="A"></el-tab-pane>
          <el-tab-pane label="已打款" name="7"></el-tab-pane>
          <el-tab-pane label="打款失败" name="8"></el-tab-pane>
        </el-tabs>

        <div class="ftabBtn flex">
          <el-button type="primary" size="small" @click="exportHandle" :loading="isExping">导出日志</el-button>
          <el-button type="primary" size="small" @click="exportDetailHandle" :loading="isExping">导出日志明细</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" @expand-change="handleExpandChange" v-loading="loading" style="width:100%">
          <el-table-column key="need" type="expand">
            <template slot-scope="props">
              <div class="expandTable">
                <el-table :data="expandTable" class="doc_table" v-loading="loading">
                  <el-table-column prop="rowNum" label="明细" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="COST_NAME" label="费用名称" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="COST_AMOUNT" label="费用金额" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="dingDanHao" label="订单号" width="120" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="lvTuGuanJiaCaiGou" label="旅途管家采购" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="caiGouLeiXing" label="采购类型" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="COST_DESC" label="用途说明" width="200" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                </el-table>
                <!-- <div class="block" style="max-width:1000px">
                  <el-pagination v-if="expandTotal>0" @current-change="currentChangeExpand" :current-page.sync="expandQuery.pageNum" :page-size="Number(expandQuery.pageSize)" @size-change="handleSizeChangeExpand" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="expandTotal"></el-pagination>
                </div> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="advanceNum" label="日志编号" min-width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="oanum" label="OA编号" min-width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="applyTime" label="发生时间" min-width="160" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>{{row.applyTime ? row.applyTime.replace('T',' ')  : ''}}</template>
          </el-table-column>
          <el-table-column prop="totalFees" label="费用金额小计" min-width="100" :show-overflow-tooltip="true" align="center">

          </el-table-column>
          <el-table-column prop="writeOffMark " label="报销单" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>{{row.writeOffMark == '1' ? '已生成' : '未生成'}}</template>
          </el-table-column>
          <el-table-column prop="applyCompany" label="申请公司" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="applyDep" label="申报部门" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="applyUserName" label="申请人" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="serviceCompany" label="服务公司" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="sevrvceDeptName" label="服务部门" min-width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="projectName" label="服务客户" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="name" label="事由描述" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="name" label="相关附件" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>
              <span @click="toDownFile(row.fileUrl)" class="blueName cp">{{row.fileName && row.fileUrl ? row.fileName : ''}}</span>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        listQuery: {
          PageModel: {
            Rows: 10,
            Page: 1,
            OrderInput: [{
              property: "applyTime",
              order: 1
            }]
          },
          id: '',
          oanum: '', //OA编号
          ApplyTimeStart: '',
          ApplyTimeEnd: '',
          advanceNum: '', //暂支编号
          busiType: '2', //暂支分类
          applyTime: '', //申请时间
          applyCompany: '', //申请公司
          applyDep: '', //申请部门
          applyDepCode: '',
          applyUserName: '', //申请人
          serviceCompany: '', //服务公司
          projectName: '', //项目
          totalFees: '', //费用金额
          costName: '', //费用名称
          applyFee: '', //申请金额
          receiptAccountName: '', //收款账户名
          receiptAccount: '', //收款账户
          depositBank: '', //收款开户行
          remitAgency: '', //打款公司
          descFees: '', ////费用说明
          oaApprovalRemarks: '', //OA审批备注
          processState: '',
          PayResult: '',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        },
        showDropScreen: -1,
        activeName: '0',
        num1: 0,
        tableData: [],
        expandTable: [],
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        loading: false,
        proNameList: [], //项目列表
        multipleSelection: [],
        permissionLists: [],
        setForm: {
          date: '',
          time: '',
          aaa: '',
        },
        isExping: false,
        expQuery: {
          PageModel: {
            Rows: 10,
            Page: 1,
            OrderInput: []
          },
          ProcessState: '',
          advanceNum: '',
          advanceId: '',
          BusiType: '2',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        }
      }
    },
    created() {
      // if (this.$route.query.id != undefined && this.$route.query.id) {
      //   this.id = this.$route.query.id;
      // }
      this.getProList();
      this.getList();
      // this.getButtonPower();
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let that = this
        let butQuery = {
          path: '/workLog',
          powerEnName: 'workLog'
        }
        xz.getbtnPowerIdBypage(butQuery).then(res => {
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                that.permissionLists.push(element.Enname);
              }
              // console.log(that.permissionLists)
            } else {
              this.permissionLists = []
            }
          } else {
            this.$message.error('获取按钮权限出错')
            this.permissionLists = []
          }
        })
      },
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      currentChange(val) {
        this.listQuery.PageModel.Page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.PageModel.Page = 1;
        this.listQuery.PageModel.Rows = val;
        this.getList();
      },
      searchHandle() {
        this.listQuery.PageModel.Page = 1;
        this.getList();
      },
      getList() {
        this.GetAdvancePageList();
      },
      GetAdvancePageList() {
        this.loading = true;
        xz.GetAdvancePageList(this.listQuery).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.pageModel.totalCount;
            this.loading = false;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      changeTab(tab) {
        if (this.activeName == '0') {
          this.getList()
        } else {
          this.loading = true;
          this.$router.push({
            path: '/logReimbursement',
            query: {
              activeName: this.activeName,
              tabName: tab.$options.propsData.label
            }
          })
        }
      },
      //展开表格
      handleExpandChange(row, rows) {
        if (rows.length > 1) {
          this.expandTable = []
          this.$refs.writeOff.toggleRowExpansion(rows[0]);
        }
        try {
          this.expandTable = JSON.parse(row.costDetail);
        } catch (err) {
          console.log(err)
          this.expandTable = [];
        }
        // this.expQuery.advanceNum = row.advanceNum;
        // this.expQuery.advanceId = row.id;
        // xz.WriteOffList(this.expQuery).then(res => {
        //   if (res.status == 'ok') {
        //     this.expandTable = res.data.data;
        //   } else {
        //     this.expandTable = [];
        //   }
        // })
      },
      toDownFile(url) {
        const newWindow = window.open(url, "_blank");
      },
      exportHandle() {
        this.isExping = true;
        let d = JSON.parse(JSON.stringify(this.listQuery));
        d.PageModel.Rows = 100000000;
        d.PageModel.Page = 1;
        xz.AdvanceExpFun(d, 'GetAdvancePageListP1').then(res => {
          if (res) {
            try {
              var data = new Blob([res], {
                type: "application/vnd.ms-excel;charset=utf-8"
              });
              var downloadUrl = window.URL.createObjectURL(data);
              var anchor = document.createElement("a");
              anchor.href = downloadUrl;
              anchor.download = "日志列表导出.xlsx";
              anchor.click();
              window.URL.revokeObjectURL(data);
              this.isExping = false;
            } catch (e) {
              this.isExping = false;
              this.$message.error('导出异常')
            }
          } else {
            this.$message.error('导出失败');
            this.getList();
            this.isExping = false;
          }
        })
      },
      exportDetailHandle() {
        this.isExping = true;
        let d = JSON.parse(JSON.stringify(this.listQuery));
        d.PageModel.Rows = 100000000;
        d.PageModel.Page = 1;
        xz.AdvanceExpFun(d, 'ExportAdvanceList').then(res => {
          if (res) {
            try {
              var data = new Blob([res], {
                type: "application/vnd.ms-excel;charset=utf-8"
              });
              var downloadUrl = window.URL.createObjectURL(data);
              var anchor = document.createElement("a");
              anchor.href = downloadUrl;
              anchor.download = "日志明细导出.xlsx";
              anchor.click();
              window.URL.revokeObjectURL(data);
              this.isExping = false;
            } catch (e) {
              this.isExping = false;
              this.$message.error('导出异常')
            }
          } else {
            this.$message.error('导出失败');
            this.getList();
            this.isExping = false;
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .calTitle {
    font-size: 14px;
    font-weight: bold;
  }

  .titleLine {
    font-size: 16px;
    color: #F59A23;
    margin-right: 3px;
  }

  .calList {
    padding-left: 40px;
    margin-top: 20px;
  }

  .calItem {
    margin-bottom: 10px;
  }

  .expandTable {
    padding-left: 50px;
  }
</style>
<style>
  .page_workLog .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_workLog .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_workLog .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_workLog .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_workLog .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_workLog .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_workLog .expandTable .el-table__empty-block {
    width: 501px;
    max-width: 501px;
    min-width: 501px;
    padding-right: 0;
  }

  .page_workLog .el-table__expand-icon {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  /*2.展开按钮未点击的样式是加号带边框*/
  .page_workLog .el-table__expand-icon .el-icon-arrow-right:before {
    content: "\e6d9";
    /* border: 1px solid #19bd92;
    padding: 2px; */
    color: #19bd92;
  }

  /*3.展开按钮点击后的样式是减号带边框*/
  .page_workLog .el-table__expand-icon--expanded .el-icon-arrow-right:before {
    content: "\e6d8";
    color: #19bd92;
  }

  .page_workLog .el-table__expand-icon {
    font-size: 22px;
  }

  .page_workLog .el-table__expand-icon>.el-icon {
    position: static;
    margin: 0 auto;
  }
</style>